var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notifications-container" }, [
    _vm.lastFiveNotifications.length > 0
      ? _c(
          "ul",
          { staticClass: "notifications" },
          _vm._l(_vm.lastFiveNotifications, function(notification, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "notification",
                class: ["is-" + notification.type]
              },
              [
                _c("button", {
                  staticClass: "delete",
                  on: {
                    click: function($event) {
                      return _vm.deleteNotification(notification.dateTime)
                    }
                  }
                }),
                _c("p", {
                  domProps: { innerHTML: _vm._s(notification.content) }
                })
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }